module.exports = wishlistRemote;